var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSecurityTestingIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9458_59064",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 47,
    height: 47
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 46.5,
    height: 46.5,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9458_59064)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.1205 27.8794H26.3759L25.421 22.5449C25.9515 22.3174 26.3786 21.9607 26.7024 21.4747C27.0262 20.9885 27.1881 20.4486 27.1881 19.8551C27.1881 19.045 26.9006 18.3525 26.3257 17.7776C25.7507 17.2026 25.0583 16.9152 24.2482 16.9152C23.4382 16.9152 22.7457 17.2026 22.1707 17.7776C21.5958 18.3525 21.3083 19.045 21.3083 19.8551C21.3083 20.4486 21.4702 20.9885 21.794 21.4747C22.1178 21.9607 22.5449 22.3174 23.0754 22.5449L22.1205 27.8794ZM24.2482 39.25C20.5944 38.2536 17.5694 36.1029 15.1731 32.798C12.7764 29.493 11.5781 25.7982 11.5781 21.7133V11.9933L24.2482 7.25L36.9183 11.9933V21.7133C36.9183 25.7982 35.72 29.493 33.3234 32.798C30.927 36.1029 27.902 38.2536 24.2482 39.25ZM24.2482 36.5796C27.1764 35.6504 29.5978 33.7921 31.5124 31.0047C33.427 28.2173 34.3843 25.1202 34.3843 21.7133V13.7312L24.2482 9.9462L14.1121 13.7312V21.7133C14.1121 25.1202 15.0694 28.2173 16.984 31.0047C18.8986 33.7921 21.32 35.6504 24.2482 36.5796Z",
    fill: "#49A3FF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurityTestingIcon);
export default __webpack_public_path__ + "static/media/securityTestingIcon.58632271f4da9b3e9d2b26a03504b54c.svg";
export { ForwardRef as ReactComponent };